import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { produce } from 'immer'
import {
  VoohCampaignRealization,
  VoohCampaignRealizationSliceEmpty,
  VoohImpressions,
  VoohImpressionsFilters,
} from './types'
import { VoohTargetRealization } from '../../../../types/campaign'

export const defaultState: VoohCampaignRealization = VoohCampaignRealizationSliceEmpty

const initialState: VoohCampaignRealization = produce(defaultState, draft => draft)

const voohCampaignRealizationSlice = createSlice({
  name: 'voohCampaignRealization',
  initialState,
  reducers: {
    setChartDataLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setChartData(
      state,
      action: PayloadAction<{ chartData: VoohImpressions[]; filters: VoohImpressionsFilters }>
    ) {
      state.chartData = action.payload.chartData
      for (const filtersKey in state.filters) {
        if (
          state.filters[filtersKey as keyof VoohImpressionsFilters].find(filter => filter.selected)
        ) {
          state.filters[filtersKey as keyof VoohImpressionsFilters] =
            action.payload.filters[filtersKey as keyof VoohImpressionsFilters]
        } else {
          state.filters[filtersKey as keyof VoohImpressionsFilters] = action.payload.filters[
            filtersKey as keyof VoohImpressionsFilters
          ].map(filterItem => {
            return { ...filterItem, selected: false }
          })
        }
      }
    },
    setTargetRealization(state, action: PayloadAction<VoohTargetRealization>) {
      state.targetRealization = action.payload
    },
    setFetchedChartData(state, action: PayloadAction<boolean>) {
      state.fetchedChartData = action.payload
    },
    setFilters(state, action: PayloadAction<VoohImpressionsFilters>) {
      state.filters = action.payload
    },
    resetRealizationData() {
      return VoohCampaignRealizationSliceEmpty
    },
  },
})

export const voohCampaignRealizationActions = voohCampaignRealizationSlice.actions

export default voohCampaignRealizationSlice
